import { render, staticRenderFns } from "./subjectList-add-or-update.vue?vue&type=template&id=18ec1d14&scoped=true"
import script from "./subjectList-add-or-update.vue?vue&type=script&lang=js"
export * from "./subjectList-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./subjectList-add-or-update.vue?vue&type=style&index=0&id=18ec1d14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ec1d14",
  null
  
)

export default component.exports